import { Typography } from '@material-ui/core';
import React from 'react';
import JSONEditor from '../../Editors/JSONEditor';
import { RawDataEntity } from '../../Modals/RawData/types';
import LogoProgress from '../../progress/LogoProgress';
import useEntityDrawer from './useEntityDrawer';

const RawDataTab = () => {
  const {
    entity: { loading, rawData },
  } = useEntityDrawer();
  if (loading) {
    return <LogoProgress />;
  }
  if (rawData?.length) {
    const rawDataEntitiesByName = rawData?.reduce(
      (
        acc: Record<string, RawDataEntity>,
        entity: RawDataEntity['JSONData'] | RawDataEntity['TextData']
      ) => {
        acc[entity.name] = entity.JSONData || entity.TextData;
        return acc;
      },
      {}
    );

    return (
      <JSONEditor
        data-testid="rawDataEditor"
        key="rawDataEditor"
        readOnly={true}
        wrap={true}
        value={JSON.stringify(rawDataEntitiesByName, null, 2)}
      />
    );
  }

  return (
    <Typography data-testid="rawDataEditor-empty" variant="body1">
      No raw data for entity.
    </Typography>
  );
};

export default RawDataTab;
